import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retryWhen, timeout} from 'rxjs/operators';
import {AppConfig} from '../app-config';
import {factory} from '../app-logging';
import {Injectable, Injector} from '@angular/core';
import * as HttpStatus from 'http-status-codes';
import {RedirectService} from '../../services/redirect.service';
import {genericRetryStrategy, ShouldRetryFn} from '../utils/rxjs-utils';

const logger = factory.getLogger('HttpErrorInterceptor');

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private redirector: RedirectService;

  constructor(private injector: Injector) {
    this.redirector = this.injector.get(RedirectService);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    logger.trace('Intercepted: ' + JSON.stringify(request));
    // Continue Request Execution
    return next.handle(request)
      .pipe(
        // Set a timeout
        timeout(AppConfig.requestTimeout),
        // Retry if the error code was greater than 500
        retryWhen(
          genericRetryStrategy({shouldRetry: ((err) => err.status > 500) as ShouldRetryFn}, 'HttpErrorInterceptor', request)),
        // Handle errors
        catchError((error: Error) => {
          if (error instanceof HttpErrorResponse) {
            const code = isNaN(error.status) ? NaN : error.status;
            logger.error(JSON.stringify(error));
            switch (code) {
              case HttpStatus.FORBIDDEN:
                this.redirector.goToErrorPage(error);
                break;
              case HttpStatus.UNAUTHORIZED:
                this.redirector.goToLoginPage();
                break;
            }
          }
          return throwError(error);
        })
      );
  }
}
